// Validation message accumulation helper.
//
// All factor-matching helpers and the main calculator push messages here.
// We pass a `MessageSink` around (rather than reaching for module state)
// so the function stays pure and testable.

import type { ValidationMessage } from "../types/validation.js";

export class MessageSink {
  private readonly messages: ValidationMessage[] = [];

  error(field: string | undefined, message: string, suggestion?: string): void {
    this.messages.push({ level: "error", field, message, suggestion });
  }

  warning(field: string | undefined, message: string, suggestion?: string): void {
    this.messages.push({ level: "warning", field, message, suggestion });
  }

  info(field: string | undefined, message: string, suggestion?: string): void {
    this.messages.push({ level: "info", field, message, suggestion });
  }

  toArray(): ValidationMessage[] {
    return [...this.messages];
  }
}
